module.exports = __webpack_public_path__ + "static/media/default_dress_code.d9847103.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/default_dress_code.png
// module id = 1030
// module chunks = 0